import React, { Fragment, useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import AntLocalization from '../../utils/AntLocalization';
import AntCondition from '../../utils/AntCondition';
import AntAPI from '../../utils/AntAPI';
import { AntGlobal } from '../../utils/AntContext';
import cs from '../../utils/const';
import './index.scss';

const RECENT_KEY = cs.System_Code + '-cmd-recent';
const MAX_RECENT = 5;
const DEBOUNCE_MS = 300;
const MIN_QUERY_LEN = 2;

const LABELS = {
    placeholder: { vi: 'T\u00ECm ki\u1EBFm...', en: 'Search...', fr: 'Rechercher...', es: 'Buscar...', id: 'Cari...', ja: '\u691C\u7D22...', zh: '\u641C\u7D22...', ko: '\uAC80\uC0C9...', hi: '\u0916\u094B\u091C\u0947\u0902...', ar: '\u0628\u062D\u062B...' },
    recent: { vi: 'G\u1EA7n \u0111\u00E2y', en: 'Recent', fr: 'R\u00E9cents', es: 'Recientes', id: 'Terbaru', ja: '\u6700\u8FD1', zh: '\u6700\u8FD1', ko: '\uCD5C\uADFC', hi: '\u0939\u093E\u0932 \u0915\u0947', ar: '\u0627\u0644\u0623\u062E\u064A\u0631\u0629' },
    quickActions: { vi: 'H\u00E0nh \u0111\u1ED9ng nhanh', en: 'Quick Actions', fr: 'Actions rapides', es: 'Acciones r\u00E1pidas', id: 'Aksi cepat', ja: '\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3', zh: '\u5FEB\u901F\u64CD\u4F5C', ko: '\uBE60\uB978 \uC791\uC5C5', hi: '\u0924\u094D\u0935\u0930\u093F\u0924 \u0915\u093E\u0930\u094D\u0930\u0935\u093E\u0908', ar: '\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0633\u0631\u064A\u0639\u0629' },
    customers: { vi: 'Kh\u00E1ch h\u00E0ng', en: 'Customers', fr: 'Clients', es: 'Clientes', id: 'Pelanggan', ja: '\u9867\u5BA2', zh: '\u5BA2\u6237', ko: '\uACE0\uAC1D', hi: '\u0917\u094D\u0930\u093E\u0939\u0915', ar: '\u0627\u0644\u0639\u0645\u0644\u0627\u0621' },
    orders: { vi: '\u0110\u01A1n h\u00E0ng', en: 'Orders', fr: 'Commandes', es: 'Pedidos', id: 'Pesanan', ja: '\u6CE8\u6587', zh: '\u8BA2\u5355', ko: '\uC8FC\uBB38', hi: '\u0911\u0930\u094D\u0921\u0930', ar: '\u0627\u0644\u0637\u0644\u0628\u0627\u062A' },
    purchaseOrders: { vi: '\u0110\u01A1n mua h\u00E0ng', en: 'Purchase Orders', fr: 'Bons de commande', es: 'Pedidos de compra', id: 'Pesanan pembelian', ja: '\u8CFC\u5165\u6CE8\u6587', zh: '\u91C7\u8D2D\u8BA2\u5355', ko: '\uAD6C\uB9E4 \uC8FC\uBB38', hi: '\u0916\u0930\u0940\u0926 \u0906\u0926\u0947\u0936', ar: '\u0623\u0648\u0627\u0645\u0631 \u0627\u0644\u0634\u0631\u0627\u0621' },
    noResults: { vi: 'Kh\u00F4ng t\u00ECm th\u1EA5y k\u1EBFt qu\u1EA3', en: 'No results found', fr: 'Aucun r\u00E9sultat', es: 'Sin resultados', id: 'Tidak ada hasil', ja: '\u7D50\u679C\u306A\u3057', zh: '\u672A\u627E\u5230\u7ED3\u679C', ko: '\uACB0\uACFC \uC5C6\uC74C', hi: '\u0915\u094B\u0908 \u092A\u0930\u093F\u0923\u093E\u092E \u0928\u0939\u0940\u0902', ar: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C' },
    createSaleOrder: { vi: 'T\u1EA1o \u0111\u01A1n b\u00E1n h\u00E0ng', en: 'Create Sale Order', fr: 'Cr\u00E9er commande de vente', es: 'Crear pedido de venta', id: 'Buat pesanan penjualan', ja: '\u8CA9\u58F2\u6CE8\u6587\u4F5C\u6210', zh: '\u521B\u5EFA\u9500\u552E\u8BA2\u5355', ko: '\uD310\uB9E4 \uC8FC\uBB38 \uC0DD\uC131', hi: '\u092C\u093F\u0915\u094D\u0930\u0940 \u0911\u0930\u094D\u0921\u0930 \u092C\u0928\u093E\u090F\u0902', ar: '\u0625\u0646\u0634\u0627\u0621 \u0623\u0645\u0631 \u0628\u064A\u0639' },
    createPurchaseOrder: { vi: 'T\u1EA1o \u0111\u01A1n mua h\u00E0ng', en: 'Create Purchase Order', fr: 'Cr\u00E9er bon de commande', es: 'Crear pedido de compra', id: 'Buat pesanan pembelian', ja: '\u8CFC\u5165\u6CE8\u6587\u4F5C\u6210', zh: '\u521B\u5EFA\u91C7\u8D2D\u8BA2\u5355', ko: '\uAD6C\uB9E4 \uC8FC\uBB38 \uC0DD\uC131', hi: '\u0916\u0930\u0940\u0926 \u0911\u0930\u094D\u0921\u0930 \u092C\u0928\u093E\u090F\u0902', ar: '\u0625\u0646\u0634\u0627\u0621 \u0623\u0645\u0631 \u0634\u0631\u0627\u0621' },
    createCashReceive: { vi: 'T\u1EA1o phi\u1EBFu thu', en: 'Create Cash Receipt', fr: 'Cr\u00E9er re\u00E7u', es: 'Crear recibo', id: 'Buat penerimaan kas', ja: '\u5165\u91D1\u4F1D\u7968\u4F5C\u6210', zh: '\u521B\u5EFA\u6536\u6B3E\u5355', ko: '\uC601\uC218\uC99D \uC0DD\uC131', hi: '\u0928\u0917\u0926 \u0930\u0938\u0940\u0926 \u092C\u0928\u093E\u090F\u0902', ar: '\u0625\u0646\u0634\u0627\u0621 \u0625\u064A\u0635\u0627\u0644 \u0642\u0628\u0636' },
    createCashIssue: { vi: 'T\u1EA1o phi\u1EBFu chi', en: 'Create Cash Issue', fr: 'Cr\u00E9er d\u00E9caissement', es: 'Crear desembolso', id: 'Buat pengeluaran kas', ja: '\u51FA\u91D1\u4F1D\u7968\u4F5C\u6210', zh: '\u521B\u5EFA\u4ED8\u6B3E\u5355', ko: '\uCD9C\uAE08 \uC804\uD45C \uC0DD\uC131', hi: '\u0928\u0917\u0926 \u092D\u0941\u0917\u0924\u093E\u0928 \u092C\u0928\u093E\u090F\u0902', ar: '\u0625\u0646\u0634\u0627\u0621 \u0633\u0646\u062F \u0635\u0631\u0641' },
    createTransfer: { vi: 'T\u1EA1o phi\u1EBFu chuy\u1EC3n kho', en: 'Create Transfer', fr: 'Cr\u00E9er transfert', es: 'Crear transferencia', id: 'Buat transfer', ja: '\u5728\u5EAB\u79FB\u52D5\u4F5C\u6210', zh: '\u521B\u5EFA\u8C03\u62E8\u5355', ko: '\uC774\uB3D9 \uC0DD\uC131', hi: '\u0938\u094D\u0925\u093E\u0928\u093E\u0902\u0924\u0930\u0923 \u092C\u0928\u093E\u090F\u0902', ar: '\u0625\u0646\u0634\u0627\u0621 \u0646\u0642\u0644' },
    items: { vi: 'S\u1EA3n ph\u1EA9m', en: 'Items', fr: 'Articles', es: 'Art\u00EDculos', id: 'Barang', ja: '\u5546\u54C1', zh: '\u5546\u54C1', ko: '\uC0C1\uD488', hi: '\u0906\u0907\u091F\u092E', ar: '\u0627\u0644\u0639\u0646\u0627\u0635\u0631' }
};

const QUICK_ACTIONS = [
    { labelKey: 'createSaleOrder', path: '/ar/AROrderCreation/', icon: 'add', visible: { whenUser: { AROrder_can_create: 1 } } },
    { labelKey: 'createPurchaseOrder', path: '/ap/APOrderCreation/', icon: 'add', visible: { whenUser: { APOrder_can_create: 1 } } },
    { labelKey: 'createCashReceive', path: '/ca/CAReceiveRequests/', icon: 'add', visible: { whenUser: { CARequest_can_create: 1 } } },
    { labelKey: 'createCashIssue', path: '/ca/CAIssueRequests/', icon: 'add', visible: { whenUser: { CARequest_can_create: 1 } } },
    { labelKey: 'createTransfer', path: '/inv/ICTransferCreation/', icon: 'add', visible: { whenUser: { ICTransfer_can_create: 1 } } }
];

const t = (key) => AntLocalization.translateText(LABELS[key] || key);

const loadRecent = () => {
    try {
        const raw = localStorage.getItem(RECENT_KEY);
        if (raw) return JSON.parse(raw);
    } catch (e) { /* ignore */ }
    return [];
};

const saveRecent = (item) => {
    let list = loadRecent();
    list = list.filter((r) => r.path !== item.path);
    list.unshift(item);
    if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) { /* ignore */ }
    return list;
};

const postAPI = (api, url, body) => {
    return new Promise((resolve) => {
        api.post(url, body, (data) => {
            if (data && data.data && data.data.rows) resolve(data.data.rows);
            else resolve([]);
        });
    });
};

const AntCommandPalette = () => {
    const appGlobal = AntGlobal();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [recentItems, setRecentItems] = useState(loadRecent);
    const [activeIndex, setActiveIndex] = useState(-1);

    const inputRef = useRef(null);
    const triggerRef = useRef(null);
    const dropdownRef = useRef(null);
    const debounceRef = useRef(null);

    const arOrderAPI = useMemo(() => new AntAPI('ar', 'AROrder'), []);
    const apOrderAPI = useMemo(() => new AntAPI('ap', 'APOrder'), []);
    const entityAPI = useMemo(() => new AntAPI('user', 'BusinessEntity'), []);
    const itemAPI = useMemo(() => new AntAPI('inv', 'Item'), []);

    const quickActions = useMemo(() => {
        return QUICK_ACTIONS.filter((a) => AntCondition.isVisible(null, { visible: a.visible }));
    }, []);

    const flatItems = useMemo(() => {
        const items = [];
        if (!query || query.length < MIN_QUERY_LEN) {
            recentItems.forEach((r) => items.push({ ...r, group: 'recent' }));
            quickActions.forEach((a) => items.push({ text: t(a.labelKey), path: a.path, type: 'action', icon: a.icon, group: 'quickActions' }));
        } else {
            results.forEach((g) => {
                g.items.forEach((item) => items.push({ ...item, group: g.key }));
            });
        }
        return items;
    }, [query, results, recentItems, quickActions]);

    const open = useCallback(() => {
        setIsOpen(true);
        setQuery('');
        setResults([]);
        setActiveIndex(-1);
        setRecentItems(loadRecent());
        setTimeout(() => { if (inputRef.current) inputRef.current.focus(); }, 50);
    }, []);

    const close = useCallback(() => {
        setIsOpen(false);
        setQuery('');
        setResults([]);
        setActiveIndex(-1);
    }, []);

    const navigateTo = useCallback((item) => {
        if (!item || !item.path) return;
        const saved = saveRecent({ text: item.text, path: item.path, type: item.type || 'page', meta: item.meta });
        setRecentItems(saved);
        close();
        navigate(item.path);
    }, [close, navigate]);

    // Global keyboard shortcut
    useEffect(() => {
        const handler = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                e.stopPropagation();
                if (isOpen) close();
                else open();
            }
            if (e.key === 'Escape' && isOpen) {
                e.preventDefault();
                close();
            }
        };
        document.addEventListener('keydown', handler, true);
        return () => document.removeEventListener('keydown', handler, true);
    }, [isOpen, open, close]);

    // Click outside to close
    useEffect(() => {
        if (!isOpen) return;
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) {
                close();
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [isOpen, close]);

    // Debounced search
    useEffect(() => {
        if (debounceRef.current) clearTimeout(debounceRef.current);

        if (!query || query.length < MIN_QUERY_LEN) {
            setResults([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        debounceRef.current = setTimeout(async () => {
            try {
                const keyword = query.trim();
                const body = { searchText: keyword, pageSize: 5, pageIndex: 0, selectFields: ['code', 'name'] };

                const [entities, arOrders, apOrders, items] = await Promise.all([
                    postAPI(entityAPI, '/user/BusinessEntity/list', { ...body, selectFields: ['code', 'name', 'phone'] }).catch(() => []),
                    postAPI(arOrderAPI, '/ar/AROrder/list', { ...body, selectFields: ['code', 'entity_name', 'total_gross_price', 'order_status'] }).catch(() => []),
                    postAPI(apOrderAPI, '/ap/APOrder/list', { ...body, selectFields: ['code', 'entity_name', 'total_gross_price', 'order_status'] }).catch(() => []),
                    postAPI(itemAPI, '/inv/Item/list', { ...body, selectFields: ['code', 'name', 'barcode'] }).catch(() => [])
                ]);

                const groups = [];

                if (entities.length > 0) {
                    groups.push({
                        key: 'customers',
                        label: t('customers'),
                        icon: 'user',
                        items: entities.map((e) => ({
                            text: e.name || e.code,
                            meta: e.code + (e.phone ? ' \u2022 ' + e.phone : ''),
                            path: '/user/BusinessEntity/' + encodeURIComponent(e.code),
                            type: 'entity'
                        }))
                    });
                }

                if (arOrders.length > 0) {
                    groups.push({
                        key: 'orders',
                        label: t('orders'),
                        icon: 'cart',
                        items: arOrders.map((o) => ({
                            text: o.code,
                            meta: (o.entity_name || '') + (o.total_gross_price ? ' \u2022 ' + Number(o.total_gross_price).toLocaleString() : ''),
                            path: '/ar/AROrder/' + encodeURIComponent(o.code),
                            type: 'order',
                            status: o.order_status
                        }))
                    });
                }

                if (apOrders.length > 0) {
                    groups.push({
                        key: 'purchaseOrders',
                        label: t('purchaseOrders'),
                        icon: 'box',
                        items: apOrders.map((o) => ({
                            text: o.code,
                            meta: (o.entity_name || '') + (o.total_gross_price ? ' \u2022 ' + Number(o.total_gross_price).toLocaleString() : ''),
                            path: '/ap/APOrder/' + encodeURIComponent(o.code),
                            type: 'purchase',
                            status: o.order_status
                        }))
                    });
                }

                if (items.length > 0) {
                    groups.push({
                        key: 'items',
                        label: t('items'),
                        icon: 'product',
                        items: items.map((i) => ({
                            text: i.name || i.code,
                            meta: i.code + (i.barcode ? ' \u2022 ' + i.barcode : ''),
                            path: '/inv/Item/' + encodeURIComponent(i.code),
                            type: 'item'
                        }))
                    });
                }

                setResults(groups);
                setActiveIndex(groups.length > 0 ? 0 : -1);
            } catch (e) {
                setResults([]);
            } finally {
                setLoading(false);
            }
        }, DEBOUNCE_MS);

        return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
    }, [query, entityAPI, arOrderAPI, apOrderAPI, itemAPI]);

    const onKeyDown = useCallback((e) => {
        const total = flatItems.length;
        if (total === 0) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setActiveIndex((prev) => (prev + 1) % total);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setActiveIndex((prev) => (prev <= 0 ? total - 1 : prev - 1));
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (activeIndex >= 0 && activeIndex < total) {
                navigateTo(flatItems[activeIndex]);
            }
        }
    }, [flatItems, activeIndex, navigateTo]);

    // Scroll active item into view
    useEffect(() => {
        if (!dropdownRef.current || activeIndex < 0) return;
        const el = dropdownRef.current.querySelector('.cmd-item.active');
        if (el) el.scrollIntoView({ block: 'nearest' });
    }, [activeIndex]);

    const getDropdownPosition = useCallback(() => {
        if (!triggerRef.current) return { top: 0, left: 0 };
        const rect = triggerRef.current.getBoundingClientRect();
        return {
            top: rect.bottom + 4,
            left: Math.max(rect.left + rect.width / 2 - 240, 8)
        };
    }, []);

    const renderIcon = (type) => {
        const icons = {
            action: '\u2795',
            entity: '\uD83D\uDC64',
            order: '\uD83D\uDCCB',
            purchase: '\uD83D\uDCE6',
            item: '\uD83D\uDCE6',
            page: '\uD83D\uDCCB',
            recent: '\uD83D\uDD52',
            add: '\u2795'
        };
        return icons[type] || '\uD83D\uDD35';
    };

    const renderDropdownContent = () => {
        const hasQuery = query && query.length >= MIN_QUERY_LEN;

        if (hasQuery && loading) {
            return <div className="cmd-loading"><div className="cmd-spinner" />{AntLocalization.translateText({ vi: '\u0110ang t\u00ECm...', en: 'Searching...', fr: 'Recherche...', es: 'Buscando...', id: 'Mencari...', ja: '\u691C\u7D22\u4E2D...', zh: '\u641C\u7D22\u4E2D...', ko: '\uAC80\uC0C9 \uC911...', hi: '\u0916\u094B\u091C \u0930\u0939\u093E \u0939\u0948...', ar: '\u062C\u0627\u0631\u064A \u0627\u0644\u0628\u062D\u062B...' })}</div>;
        }

        if (hasQuery && results.length === 0 && !loading) {
            return <div className="cmd-empty">{t('noResults')}</div>;
        }

        if (!hasQuery) {
            let idx = 0;
            return (
                <Fragment>
                    {recentItems.length > 0 && (
                        <div className="cmd-group">
                            <div className="cmd-group-label">{t('recent')}</div>
                            {recentItems.map((item, i) => {
                                const currentIdx = idx++;
                                return (
                                    <div
                                        key={'r-' + i}
                                        className={'cmd-item' + (activeIndex === currentIdx ? ' active' : '')}
                                        onClick={() => navigateTo(item)}
                                        onMouseEnter={() => setActiveIndex(currentIdx)}
                                    >
                                        <span className="cmd-item-icon">{renderIcon('recent')}</span>
                                        <span className="cmd-item-text">{item.text}</span>
                                        {item.meta && <span className="cmd-item-meta">{item.meta}</span>}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {quickActions.length > 0 && (
                        <div className="cmd-group">
                            <div className="cmd-group-label">{t('quickActions')}</div>
                            {quickActions.map((action, i) => {
                                const currentIdx = idx++;
                                return (
                                    <div
                                        key={'a-' + i}
                                        className={'cmd-item' + (activeIndex === currentIdx ? ' active' : '')}
                                        onClick={() => navigateTo({ text: t(action.labelKey), path: action.path, type: 'action' })}
                                        onMouseEnter={() => setActiveIndex(currentIdx)}
                                    >
                                        <span className="cmd-item-icon">{renderIcon('add')}</span>
                                        <span className="cmd-item-text">{t(action.labelKey)}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </Fragment>
            );
        }

        // Search results
        let idx = 0;
        return results.map((group) => (
            <div key={group.key} className="cmd-group">
                <div className="cmd-group-label">{group.label} ({group.items.length})</div>
                {group.items.map((item, i) => {
                    const currentIdx = idx++;
                    return (
                        <div
                            key={group.key + '-' + i}
                            className={'cmd-item' + (activeIndex === currentIdx ? ' active' : '')}
                            onClick={() => navigateTo(item)}
                            onMouseEnter={() => setActiveIndex(currentIdx)}
                        >
                            <span className="cmd-item-icon">{renderIcon(item.type)}</span>
                            <div className="cmd-item-content">
                                <span className="cmd-item-text">{item.text}</span>
                                {item.meta && <span className="cmd-item-meta">{item.meta}</span>}
                            </div>
                            {item.status && <span className={'cmd-item-status cmd-status-' + String(item.status).toLowerCase()}>{item.status}</span>}
                        </div>
                    );
                })}
            </div>
        ));
    };

    const pos = isOpen ? getDropdownPosition() : { top: 0, left: 0 };

    return (
        <Fragment>
            <div className="cmd-trigger" ref={triggerRef} onClick={open}>
                <svg className="cmd-trigger-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <span className="cmd-trigger-text">{t('placeholder')}</span>
                <span className="cmd-trigger-shortcut">{navigator.platform && navigator.platform.indexOf('Mac') > -1 ? '⌘K' : 'Ctrl+K'}</span>
            </div>
            {isOpen && ReactDOM.createPortal(
                <Fragment>
                    <div className="cmd-overlay" onClick={close} />
                    <div className="cmd-dropdown" ref={dropdownRef}>
                        <div className="cmd-search">
                            <svg className="cmd-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="11" cy="11" r="8" />
                                <line x1="21" y1="21" x2="16.65" y2="16.65" />
                            </svg>
                            <input
                                ref={inputRef}
                                className="cmd-search-input"
                                type="text"
                                placeholder={t('placeholder')}
                                value={query}
                                onChange={(e) => { setQuery(e.target.value); setActiveIndex(-1); }}
                                onKeyDown={onKeyDown}
                                autoComplete="off"
                                spellCheck={false}
                            />
                        </div>
                        <div className="cmd-body">
                            {renderDropdownContent()}
                        </div>
                    </div>
                </Fragment>,
                document.body
            )}
        </Fragment>
    );
};

export default AntCommandPalette;
